import _slicedToArray from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { randomString } from "./crypto";
import { OidcMetadataClient } from "./OidcMetadataClient";
import * as QueryString from "./querystring";
export var OidcClient =
/*#__PURE__*/
function () {
  function OidcClient(settings) {
    var oidcMetadataClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new OidcMetadataClient(settings.authority);

    _classCallCheck(this, OidcClient);

    this.settings = settings;
    this.oidcMetadataClient = oidcMetadataClient;
  }

  _createClass(OidcClient, [{
    key: "createAuthorizationParams",
    value: function () {
      var _createAuthorizationParams = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var extra,
            _this$settings,
            client_id,
            scope,
            _this$settings$extra,
            defaultExtra,
            defaults,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                extra = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _this$settings = this.settings, client_id = _this$settings.client_id, scope = _this$settings.scope, _this$settings$extra = _this$settings.extra, defaultExtra = _this$settings$extra === void 0 ? {} : _this$settings$extra;
                defaults = {
                  client_id: client_id,
                  state: randomString(32),
                  nonce: randomString(32),
                  scope: scope
                };
                return _context.abrupt("return", Object.assign(defaults, defaultExtra, extra));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createAuthorizationParams() {
        return _createAuthorizationParams.apply(this, arguments);
      }

      return createAuthorizationParams;
    }()
  }, {
    key: "createAuthorizationUrl",
    value: function () {
      var _createAuthorizationUrl = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(params) {
        var _ref, url, query;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.oidcMetadataClient.getMetadata();

              case 2:
                _ref = _context2.sent;
                url = _ref.authorization_endpoint;
                query = QueryString.stringify(params);

                if (query) {
                  url += "?" + query;
                }

                return _context2.abrupt("return", url);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createAuthorizationUrl(_x) {
        return _createAuthorizationUrl.apply(this, arguments);
      }

      return createAuthorizationUrl;
    }()
  }, {
    key: "parseAuthorizationResponse",
    value: function () {
      var _parseAuthorizationResponse = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(callbackUrl) {
        var _callbackUrl$split, _callbackUrl$split2, _, _callbackUrl$split2$, search, authorizationResponse;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _callbackUrl$split = callbackUrl.split(/[#?]/g), _callbackUrl$split2 = _slicedToArray(_callbackUrl$split, 2), _ = _callbackUrl$split2[0], _callbackUrl$split2$ = _callbackUrl$split2[1], search = _callbackUrl$split2$ === void 0 ? "" : _callbackUrl$split2$;
                authorizationResponse = QueryString.parse(search);
                return _context3.abrupt("return", this.ensureSuccessReponse(authorizationResponse));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function parseAuthorizationResponse(_x2) {
        return _parseAuthorizationResponse.apply(this, arguments);
      }

      return parseAuthorizationResponse;
    }()
  }, {
    key: "createEndSessionUrl",
    value: function () {
      var _createEndSessionUrl = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(request) {
        var _ref2, url, query;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.oidcMetadataClient.getMetadata();

              case 2:
                _ref2 = _context4.sent;
                url = _ref2.end_session_endpoint;
                query = QueryString.stringify(request);

                if (query) {
                  url += "?" + query;
                }

                return _context4.abrupt("return", url);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function createEndSessionUrl(_x3) {
        return _createEndSessionUrl.apply(this, arguments);
      }

      return createEndSessionUrl;
    }()
  }, {
    key: "performTokenRequest",
    value: function () {
      var _performTokenRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(request) {
        var _this = this;

        var _ref3, token_endpoint;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.oidcMetadataClient.getMetadata();

              case 2:
                _ref3 = _context5.sent;
                token_endpoint = _ref3.token_endpoint;
                _context5.next = 6;
                return this.fetch(token_endpoint, {
                  method: "POST",
                  headers: {
                    "Authorization": this.getBasicAuth(),
                    "Accept": "application/json;charset=UTF-8",
                    "Content-Type": "application/x-www-form-urlencoded"
                  },
                  body: QueryString.stringify(request)
                }).then(function (response) {
                  return response.json();
                }) // do not check `response.ok` because `bad request` is also json
                .then(function (response) {
                  return _this.ensureSuccessReponse(response);
                });

              case 6:
                return _context5.abrupt("return", _context5.sent);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function performTokenRequest(_x4) {
        return _performTokenRequest.apply(this, arguments);
      }

      return performTokenRequest;
    }()
  }, {
    key: "fetch",
    value: function fetch(uri, payload) {
      return window.fetch(uri, payload);
    }
  }, {
    key: "getBasicAuth",
    value: function getBasicAuth() {
      var _this$settings2 = this.settings,
          client_id = _this$settings2.client_id,
          client_secret = _this$settings2.client_secret;
      return "Basic " + btoa(client_id + ":" + client_secret);
    }
  }, {
    key: "ensureSuccessReponse",
    value: function ensureSuccessReponse(response) {
      if ("error" in response) {
        throw new Error(response["error_description"] || response["error"]);
      }

      return response;
    }
  }]);

  return OidcClient;
}();